import { Component } from "@angular/core";
import { NavParams, ViewController } from "ionic-angular";
import { StrackerPage } from "../../tracker/sencha-tracker/stracker";

@Component({
    selector: "bib-number",
    templateUrl: "bib-number.html"
})
export class BibNumberComponent {
    scope: any;
    viewClose: Promise<any> = null;

    constructor(private navParams: NavParams, private viewCtrl: ViewController) {
        this.scope = navParams.get('scope');
        this.viewClose = navParams.get('viewClose');

        this.viewClose.then(() => {
            this.onDismiss();
        });
    }

    onDismiss() {
        this.viewCtrl.dismiss();
    }
}



// WEBPACK FOOTER //
// /src/components/bib-number/bib-number.ts